import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { ClienteCentralCompraParticipanteSelectModule } from '../participante/select';

import { ClienteCentralCompraSelectParticipanteModalComponent } from './cliente-central-compra-select-participante-modal.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteCentralCompraParticipanteSelectModule
    ],
    declarations: [
        ClienteCentralCompraSelectParticipanteModalComponent
    ],
    exports: [
        ClienteCentralCompraSelectParticipanteModalComponent
    ]
})
export class ClienteCentralCompraSelectParticipanteModalModule { }
